module.exports = __webpack_public_path__ + "static/media/trash-black.990fa017.svg";